// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AuthLogoutData,
  AuthLogoutResponses,
  CancelPaymentData,
  CancelPaymentErrors,
  CancelPaymentResponses,
  CancelProjectData,
  CancelProjectResponses,
  CompleteWelcomeCallData,
  CompleteWelcomeCallResponses,
  ConfirmOtpData,
  ConfirmOtpResponses,
  CreateAgreementData,
  CreateAgreementResponses,
  CreateConnectedAccountData,
  CreateConnectedAccountResponses,
  CreateIdentityVerificationSetupData,
  CreateIdentityVerificationSetupErrors,
  CreateIdentityVerificationSetupResponses,
  CreateInsightData,
  CreateInsightErrors,
  CreateInsightResponses,
  CreateInviteData,
  CreateInviteErrors,
  CreateInviteResponses,
  CreateMediaData,
  CreateMediaResponses,
  CreateMfaRefreshSessionData,
  CreateMfaRefreshSessionResponses,
  CreatePaymentMethodData,
  CreatePaymentMethodErrors,
  CreatePaymentMethodResponses,
  CreatePlaidLinkTokenData,
  CreatePlaidLinkTokenErrors,
  CreatePlaidLinkTokenResponses,
  CreateProjectData,
  CreateProjectErrors,
  CreateProjectResponses,
  CreatePropertyData,
  CreatePropertyErrors,
  CreatePropertyResponses,
  CreateSignatureData,
  CreateSignatureErrors,
  CreateSignatureResponses,
  DeleteConnectedAccountData,
  DeleteConnectedAccountResponses,
  DeletePaymentMethodData,
  DeletePaymentMethodErrors,
  DeletePaymentMethodResponses,
  ExchangeSutForTokenV2Data,
  ExchangeSutForTokenV2Responses,
  GenerateSutV2Data,
  GenerateSutV2Responses,
  GetAchievementsData,
  GetAchievementsResponses,
  GetActiveQuoteData,
  GetActiveQuoteErrors,
  GetActiveQuoteResponses,
  GetAuthStatusData,
  GetAuthStatusResponses,
  GetConnectedAccountsData,
  GetConnectedAccountsResponses,
  GetContractSignUrlData,
  GetContractSignUrlResponses,
  GetConversationsData,
  GetConversationsResponses,
  GetCreditApplicationUrlData,
  GetCreditApplicationUrlResponses,
  GetCurrentUserData,
  GetCurrentUserResponses,
  GetCurrentUserV3Data,
  GetCurrentUserV3Responses,
  GetCurrentWeeklyEnergyBudgetData,
  GetCurrentWeeklyEnergyBudgetResponses,
  GetDataData,
  GetDataResponses,
  GetDocumentData,
  GetDocumentErrors,
  GetDocumentResponses,
  GetEstimatedProductionData,
  GetEstimatedProductionErrors,
  GetEstimatedProductionResponses,
  GetFeaturedManufacturersData,
  GetFeaturedManufacturersResponses,
  GetFinanceAccountData,
  GetFinanceAccountDocumentData,
  GetFinanceAccountDocumentResponses,
  GetFinanceAccountDocumentsData,
  GetFinanceAccountDocumentsResponses,
  GetFinanceAccountResponses,
  GetFinanceAccountsData,
  GetFinanceAccountsResponses,
  GetInsightData,
  GetInsightErrors,
  GetInsightResponses,
  GetInsightsData,
  GetInsightsResponses,
  GetIntercomJwtData,
  GetIntercomJwtResponses,
  GetLatestInsightData,
  GetLatestInsightErrors,
  GetLatestInsightResponses,
  GetLifetimeSavingsData,
  GetLifetimeSavingsResponses,
  GetManufacturersData,
  GetManufacturersResponses,
  GetMeData,
  GetMeResponses,
  GetOtpOptionsData,
  GetOtpOptionsErrors,
  GetOtpOptionsResponses,
  GetPaymentMethodsData,
  GetPaymentMethodsErrors,
  GetPaymentMethodsResponses,
  GetPointTransactionsData,
  GetPointTransactionsResponses,
  GetProductData,
  GetProductErrors,
  GetProductResponses,
  GetProductSavingsData,
  GetProductSavingsErrors,
  GetProductSavingsResponses,
  GetProjectData,
  GetProjectDisclosuresData,
  GetProjectDisclosuresErrors,
  GetProjectDisclosuresResponses,
  GetProjectDocumentsData,
  GetProjectDocumentsResponses,
  GetProjectResponses,
  GetProjectsData,
  GetProjectsResponses,
  GetPropertyAlertsDailySeverityData,
  GetPropertyAlertsDailySeverityErrors,
  GetPropertyAlertsDailySeverityResponses,
  GetPropertyAlertsData,
  GetPropertyAlertsErrors,
  GetPropertyAlertsResponses,
  GetPropertyBatteryEnergyTotalsData,
  GetPropertyBatteryEnergyTotalsErrors,
  GetPropertyBatteryEnergyTotalsResponses,
  GetPropertyData,
  GetPropertyEnergyMaxData,
  GetPropertyEnergyMaxErrors,
  GetPropertyEnergyMaxResponses,
  GetPropertyErrors,
  GetPropertyResponses,
  GetPropertyTariffsData,
  GetPropertyTariffsResponses,
  GetPropertyUtilitiesData,
  GetPropertyUtilitiesErrors,
  GetPropertyUtilitiesResponses,
  GetPropertyWeatherData,
  GetPropertyWeatherErrors,
  GetPropertyWeatherResponses,
  GetQuestionnaireData,
  GetQuestionnaireErrors,
  GetQuestionnaireResponses,
  GetQuestionsData,
  GetQuestionsResponses,
  GetQuizQuestionsData,
  GetQuizQuestionsErrors,
  GetQuizQuestionsResponses,
  GetRatePlanEligibilityData,
  GetRatePlanEligibilityErrors,
  GetRatePlanEligibilityResponses,
  GetRatePlanOptionsData,
  GetRatePlanOptionsResponses,
  GetSignupLinkData,
  GetSignupLinkErrors,
  GetSignupLinkResponses,
  GetSimulatedProductionData,
  GetSimulatedProductionErrors,
  GetSimulatedProductionResponses,
  GetSystemDetailsData,
  GetSystemDetailsResponses,
  GetTasksData,
  GetTasksResponses,
  GetTicketData,
  GetTicketErrors,
  GetTicketResponses,
  GetTicketsData,
  GetTicketsResponses,
  GetUpgradesData,
  GetUpgradesResponses,
  GetUserData,
  GetUserErrors,
  GetUserFeedbackData,
  GetUserFeedbackResponses,
  GetUserPropertiesData,
  GetUserPropertiesResponses,
  GetUserResponses,
  GetWeeklyEnergyBudgetData,
  GetWeeklyEnergyBudgetResponses,
  GetWelcomeCallUrlData,
  GetWelcomeCallUrlResponses,
  GetWrapped2025Data,
  GetWrapped2025Errors,
  GetWrapped2025Responses,
  InitiateEmailChangeData,
  InitiateEmailChangeErrors,
  InitiateEmailChangeResponses,
  LoginData,
  LoginErrors,
  LoginResponses,
  MarkProjectViewsData,
  MarkProjectViewsResponses,
  MarkWeeklyEnergyBudgetViewedData,
  MarkWeeklyEnergyBudgetViewedResponses,
  PostCouponCodeData,
  PostCouponCodeResponses,
  PostPaymentData,
  PostPaymentErrors,
  PostPaymentResponses,
  PostQuestData,
  PostQuestErrors,
  PostQuestResponses,
  PostUserFeedbackData,
  PostUserFeedbackResponses,
  PutQuestData,
  PutQuestErrors,
  PutQuestResponses,
  ReopenConversationData,
  ReopenConversationErrors,
  ReopenConversationResponses,
  RestartEmailChangeVerificationData,
  RestartEmailChangeVerificationResponses,
  SearchByAssociatedEntityData,
  SearchByAssociatedEntityErrors,
  SearchByAssociatedEntityResponses,
  SearchFeedItemsData,
  SearchFeedItemsErrors,
  SearchFeedItemsResponses,
  SearchProductsData,
  SearchProductsResponses,
  SearchSavingsData,
  SearchSavingsResponses,
  SendOtp2Data,
  SendOtp2Errors,
  SendOtp2Responses,
  SendOtpData,
  SendOtpErrors,
  SendOtpResponses,
  SetDefaultPaymentMethodData,
  SetDefaultPaymentMethodErrors,
  SetDefaultPaymentMethodResponses,
  SignupData,
  SignupErrors,
  SignupResponses,
  StreamDocumentData,
  StreamDocumentResponses,
  SubmitAnswerData,
  SubmitAnswerResponses,
  SubmitCreditApplicationData,
  SubmitCreditApplicationErrors,
  SubmitCreditApplicationResponses,
  UpdateConnectedAccountData,
  UpdateConnectedAccountResponses,
  UpdateCredentialsData,
  UpdateCredentialsResponses,
  UpdateFeedItemStatusData,
  UpdateFeedItemStatusResponses,
  UpdateProjectFeedItemStatusData,
  UpdateProjectFeedItemStatusResponses,
  UpdatePropertyBuildingData,
  UpdatePropertyBuildingResponses,
  UpdatePropertyData,
  UpdatePropertyErrors,
  UpdatePropertyResponses,
  UploadMediaData,
  UploadMediaResponses,
  UploadProjectDocumentsData,
  UploadProjectDocumentsErrors,
  UploadProjectDocumentsResponses,
  ValidateAgreementData,
  ValidateAgreementResponses,
  VerifyEmailChangeData,
  VerifyEmailChangeResponses,
  VerifyPlaidAccountData,
  VerifyPlaidAccountErrors,
  VerifyPlaidAccountResponses,
  ViewAchievementData,
  ViewAchievementErrors,
  ViewAchievementResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const getData = <ThrowOnError extends boolean = false>(
  options?: Options<GetDataData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetDataResponses, unknown, ThrowOnError>({
    url: "/api/ok",
    ...options,
  });

export const getCurrentUser = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentUserData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCurrentUserResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/users",
    ...options,
  });

export const confirmOtp = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmOtpData, ThrowOnError>
) =>
  (options.client ?? client).post<ConfirmOtpResponses, unknown, ThrowOnError>({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/users/confirm-otp",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getCurrentUserV3 = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentUserV3Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCurrentUserV3Responses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v3/users",
    ...options,
  });

export const getIntercomJwt = <ThrowOnError extends boolean = false>(
  options?: Options<GetIntercomJwtData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetIntercomJwtResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v3/users/intercom-jwt",
    ...options,
  });

export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    url: "/api/v3/users/me",
    ...options,
  });

export const getUserProperties = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserPropertiesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetUserPropertiesResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties",
    ...options,
  });

/**
 * Create a property for the authenticated user
 */
export const createProperty = <ThrowOnError extends boolean = false>(
  options: Options<CreatePropertyData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePropertyResponses,
    CreatePropertyErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get a property by id
 */
export const getProperty = <ThrowOnError extends boolean = false>(
  options: Options<GetPropertyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPropertyResponses,
    GetPropertyErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}",
    ...options,
  });

/**
 * Update the electric utility and/or address of a property
 */
export const updateProperty = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePropertyData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdatePropertyResponses,
    UpdatePropertyErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getWeeklyEnergyBudget = <ThrowOnError extends boolean = false>(
  options: Options<GetWeeklyEnergyBudgetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetWeeklyEnergyBudgetResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/weekly-energy-budgets",
    ...options,
  });

export const getCurrentWeeklyEnergyBudget = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetCurrentWeeklyEnergyBudgetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetCurrentWeeklyEnergyBudgetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/weekly-energy-budgets/current-week",
    ...options,
  });

export const markWeeklyEnergyBudgetViewed = <
  ThrowOnError extends boolean = false
>(
  options: Options<MarkWeeklyEnergyBudgetViewedData, ThrowOnError>
) =>
  (options.client ?? client).post<
    MarkWeeklyEnergyBudgetViewedResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/weekly-energy-budgets/{budgetId}/view",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get available tariffs for a property
 */
export const getPropertyTariffs = <ThrowOnError extends boolean = false>(
  options: Options<GetPropertyTariffsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPropertyTariffsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/tariffs",
    ...options,
  });

/**
 * Get the potential electric utilities for a property
 */
export const getPropertyUtilities = <ThrowOnError extends boolean = false>(
  options: Options<GetPropertyUtilitiesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPropertyUtilitiesResponses,
    GetPropertyUtilitiesErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/utilities",
    ...options,
  });

/**
 * Get alerts for a property
 */
export const getPropertyAlerts = <ThrowOnError extends boolean = false>(
  options: Options<GetPropertyAlertsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPropertyAlertsResponses,
    GetPropertyAlertsErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/alerts",
    ...options,
  });

/**
 * Get per-day alert severity for a property over a date range
 *
 * Known limitation: Sienna has no date-range filter or documented sort, so the alert walk is capped (~200 actionable alerts per site). A site whose history exceeds the cap may return incomplete days (some shown as `normal` when they were degraded), logged server-side. Pending a Sienna date-range filter or a guaranteed sort order to make this exact for high-volume sites.
 */
export const getPropertyAlertsDailySeverity = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetPropertyAlertsDailySeverityData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPropertyAlertsDailySeverityResponses,
    GetPropertyAlertsDailySeverityErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/alerts/daily-severity",
    ...options,
  });

/**
 * Get utility rate plan eligibility for a property
 */
export const getRatePlanEligibility = <ThrowOnError extends boolean = false>(
  options: Options<GetRatePlanEligibilityData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetRatePlanEligibilityResponses,
    GetRatePlanEligibilityErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/rate-plan-eligibility",
    ...options,
  });

/**
 * Get available utility rate plan options and benchmarks for a property
 */
export const getRatePlanOptions = <ThrowOnError extends boolean = false>(
  options: Options<GetRatePlanOptionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetRatePlanOptionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/rate-plan-options",
    ...options,
  });

/**
 * Get weather conditions for a property
 */
export const getPropertyWeather = <ThrowOnError extends boolean = false>(
  options: Options<GetPropertyWeatherData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPropertyWeatherResponses,
    GetPropertyWeatherErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/weather",
    ...options,
  });

/**
 * Get the largest energy reading over a property lifetime, for a given interval
 */
export const getPropertyEnergyMax = <ThrowOnError extends boolean = false>(
  options: Options<GetPropertyEnergyMaxData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPropertyEnergyMaxResponses,
    GetPropertyEnergyMaxErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/energy/max",
    ...options,
  });

/**
 * Get the energy charged into and discharged from a property battery on a given date
 */
export const getPropertyBatteryEnergyTotals = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetPropertyBatteryEnergyTotalsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPropertyBatteryEnergyTotalsResponses,
    GetPropertyBatteryEnergyTotalsErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/energy/battery-totals",
    ...options,
  });

export const updatePropertyBuilding = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePropertyBuildingData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdatePropertyBuildingResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/properties/{id}/building",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search savings data for a property over a date range
 */
export const searchSavings = <ThrowOnError extends boolean = false>(
  options: Options<SearchSavingsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SearchSavingsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/savings/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get total lifetime savings for a property
 */
export const getLifetimeSavings = <ThrowOnError extends boolean = false>(
  options: Options<GetLifetimeSavingsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLifetimeSavingsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/savings/lifetime",
    ...options,
  });

/**
 * Get connected accounts for the authenticated user
 */
export const getConnectedAccounts = <ThrowOnError extends boolean = false>(
  options?: Options<GetConnectedAccountsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetConnectedAccountsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/connected-accounts",
    ...options,
  });

/**
 * Create a new connected account
 */
export const createConnectedAccount = <ThrowOnError extends boolean = false>(
  options: Options<CreateConnectedAccountData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateConnectedAccountResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/connected-accounts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create an MFA refresh session for a connected account
 */
export const createMfaRefreshSession = <ThrowOnError extends boolean = false>(
  options: Options<CreateMfaRefreshSessionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    CreateMfaRefreshSessionResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/connected-accounts/{id}/mfa-refresh-session",
    ...options,
  });

/**
 * Create a credential update session for a connected account
 */
export const updateCredentials = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCredentialsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UpdateCredentialsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/connected-accounts/{id}/credential-update-session",
    ...options,
  });

/**
 * Delete a connected account
 */
export const deleteConnectedAccount = <ThrowOnError extends boolean = false>(
  options: Options<DeleteConnectedAccountData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteConnectedAccountResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/connected-accounts/{id}",
    ...options,
  });

/**
 * Update connected account status
 */
export const updateConnectedAccount = <ThrowOnError extends boolean = false>(
  options: Options<UpdateConnectedAccountData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateConnectedAccountResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/connected-accounts/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get achievements for the authenticated user
 */
export const getAchievements = <ThrowOnError extends boolean = false>(
  options?: Options<GetAchievementsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetAchievementsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/achievements",
    ...options,
  });

/**
 * Mark an achievement as viewed
 */
export const viewAchievement = <ThrowOnError extends boolean = false>(
  options: Options<ViewAchievementData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ViewAchievementResponses,
    ViewAchievementErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/achievements/{id}/view",
    ...options,
  });

export const initiateEmailChange = <ThrowOnError extends boolean = false>(
  options: Options<InitiateEmailChangeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    InitiateEmailChangeResponses,
    InitiateEmailChangeErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/users/email-changes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const verifyEmailChange = <ThrowOnError extends boolean = false>(
  options: Options<VerifyEmailChangeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VerifyEmailChangeResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/users/email-changes/{id}/verify",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const restartEmailChangeVerification = <
  ThrowOnError extends boolean = false
>(
  options: Options<RestartEmailChangeVerificationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RestartEmailChangeVerificationResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/users/email-changes/{id}/restart",
    ...options,
  });

/**
 * Get AI-generated quiz questions
 *
 * Returns quiz questions for a literature URL, excluding previously answered ones. Generates if needed.
 */
export const getQuizQuestions = <ThrowOnError extends boolean = false>(
  options: Options<GetQuizQuestionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetQuizQuestionsResponses,
    GetQuizQuestionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/ai-quiz",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get savings estimate for a single product
 */
export const getProductSavings = <ThrowOnError extends boolean = false>(
  options: Options<GetProductSavingsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProductSavingsResponses,
    GetProductSavingsErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/products/{id}/savings",
    ...options,
  });

/**
 * Get all unique manufacturers from helios products
 */
export const getManufacturers = <ThrowOnError extends boolean = false>(
  options?: Options<GetManufacturersData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetManufacturersResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/products/manufacturers",
    ...options,
  });

/**
 * Get a single helios product by classification ID. Auth is optional.
 */
export const getProduct = <ThrowOnError extends boolean = false>(
  options: Options<GetProductData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProductResponses,
    GetProductErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/products/{id}",
    ...options,
  });

/**
 * Redeem a coupon code using points
 */
export const postCouponCode = <ThrowOnError extends boolean = false>(
  options: Options<PostCouponCodeData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostCouponCodeResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/products/coupon-codes/{id}",
    ...options,
  });

/**
 * Search helios products, optionally filtered by user eligibility. Auth is optional.
 */
export const searchProducts = <ThrowOnError extends boolean = false>(
  options?: Options<SearchProductsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    SearchProductsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/products/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Get featured manufacturers for the shop
 */
export const getFeaturedManufacturers = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeaturedManufacturersData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetFeaturedManufacturersResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/v2/shop/featured-manufacturers",
    ...options,
  });

/**
 * Get shop upgrades.
 */
export const getUpgrades = <ThrowOnError extends boolean = false>(
  options?: Options<GetUpgradesData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetUpgradesResponses, unknown, ThrowOnError>({
    responseType: "json",
    url: "/api/v2/shop/upgrades",
    ...options,
  });

export const getProjects = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectsData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetProjectsResponses, unknown, ThrowOnError>({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects",
    ...options,
  });

/**
 * Create a project for the authenticated user from a consumer reservation or their Sabal accounts
 */
export const createProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateProjectData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateProjectResponses,
    CreateProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getProject = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<GetProjectResponses, unknown, ThrowOnError>({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}",
    ...options,
  });

/**
 * Cancel a project for the authenticated user
 */
export const cancelProject = <ThrowOnError extends boolean = false>(
  options: Options<CancelProjectData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    CancelProjectResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Mark the current stage education sequence and/or project timeline as viewed
 */
export const markProjectViews = <ThrowOnError extends boolean = false>(
  options: Options<MarkProjectViewsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    MarkProjectViewsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/views",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update the status of a feed item, identified by type, for a project owned by the authenticated user
 */
export const updateProjectFeedItemStatus = <
  ThrowOnError extends boolean = false
>(
  options: Options<UpdateProjectFeedItemStatusData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateProjectFeedItemStatusResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/feed-items/{feedItemType}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getCreditApplicationUrl = <ThrowOnError extends boolean = false>(
  options?: Options<GetCreditApplicationUrlData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetCreditApplicationUrlResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/credit-application-url",
    ...options,
  });

export const getContractSignUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetContractSignUrlData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetContractSignUrlResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/contract-sign-url",
    ...options,
  });

export const getWelcomeCallUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetWelcomeCallUrlData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetWelcomeCallUrlResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/welcome-call-url",
    ...options,
  });

export const completeWelcomeCall = <ThrowOnError extends boolean = false>(
  options: Options<CompleteWelcomeCallData, ThrowOnError>
) =>
  (options.client ?? client).get<
    CompleteWelcomeCallResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/welcome-call-completed",
    ...options,
  });

export const getSystemDetails = <ThrowOnError extends boolean = false>(
  options: Options<GetSystemDetailsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSystemDetailsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/system-details",
    ...options,
  });

export const getActiveQuote = <ThrowOnError extends boolean = false>(
  options: Options<GetActiveQuoteData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetActiveQuoteResponses,
    GetActiveQuoteErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/quotes/active",
    ...options,
  });

/**
 * Get disclosures for this project from the financing partner
 */
export const getProjectDisclosures = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectDisclosuresData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectDisclosuresResponses,
    GetProjectDisclosuresErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/disclosures",
    ...options,
  });

/**
 * Get BEM-estimated production series for this project
 */
export const getEstimatedProduction = <ThrowOnError extends boolean = false>(
  options: Options<GetEstimatedProductionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetEstimatedProductionResponses,
    GetEstimatedProductionErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/estimated-production",
    ...options,
  });

/**
 * Get BEM-simulated production so far for today, this week and this year
 */
export const getSimulatedProduction = <ThrowOnError extends boolean = false>(
  options: Options<GetSimulatedProductionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSimulatedProductionResponses,
    GetSimulatedProductionErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/simulated-production",
    ...options,
  });

/**
 * Submit a credit application to the financing partner for this project
 */
export const submitCreditApplication = <ThrowOnError extends boolean = false>(
  options: Options<SubmitCreditApplicationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SubmitCreditApplicationResponses,
    SubmitCreditApplicationErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/credit-application",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a Stripe identity verification session for this project
 */
export const createIdentityVerificationSetup = <
  ThrowOnError extends boolean = false
>(
  options: Options<CreateIdentityVerificationSetupData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateIdentityVerificationSetupResponses,
    CreateIdentityVerificationSetupErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/identity-verification",
    ...options,
  });

/**
 * Get the signed documents (contracts, disclosures, questionnaires) for this project
 */
export const getProjectDocuments = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectDocumentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectDocumentsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/documents",
    ...options,
  });

/**
 * Upload documents that fulfill a feed item requirement for this project
 */
export const uploadProjectDocuments = <ThrowOnError extends boolean = false>(
  options: Options<UploadProjectDocumentsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UploadProjectDocumentsResponses,
    UploadProjectDocumentsErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/documents",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });

/**
 * Stream a project document from the financing partner
 */
export const streamDocument = <ThrowOnError extends boolean = false>(
  options: Options<StreamDocumentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    StreamDocumentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/projects/{id}/document",
    ...options,
  });

/**
 * Get a questionnaire by id for the authenticated user
 */
export const getQuestionnaire = <ThrowOnError extends boolean = false>(
  options: Options<GetQuestionnaireData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetQuestionnaireResponses,
    GetQuestionnaireErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/questionnaires/{id}",
    ...options,
  });

/**
 * Create a signature for the authenticated user
 */
export const createSignature = <ThrowOnError extends boolean = false>(
  options: Options<CreateSignatureData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateSignatureResponses,
    CreateSignatureErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/signatures",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get paginated Intercom conversation history for the authenticated user
 */
export const getConversations = <ThrowOnError extends boolean = false>(
  options?: Options<GetConversationsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetConversationsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/support/conversations",
    ...options,
  });

/**
 * Reopen a closed Intercom conversation for the authenticated user
 */
export const reopenConversation = <ThrowOnError extends boolean = false>(
  options: Options<ReopenConversationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ReopenConversationResponses,
    ReopenConversationErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/support/conversations/{id}/reopen",
    ...options,
  });

/**
 * Get paginated external-facing support tickets for the authenticated user
 */
export const getTickets = <ThrowOnError extends boolean = false>(
  options?: Options<GetTicketsData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetTicketsResponses, unknown, ThrowOnError>({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/support/tickets",
    ...options,
  });

/**
 * Get one external-facing support ticket for the authenticated user
 */
export const getTicket = <ThrowOnError extends boolean = false>(
  options: Options<GetTicketData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetTicketResponses,
    GetTicketErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/support/tickets/{id}",
    ...options,
  });

/**
 * Get the latest version of a customer terms document
 */
export const getDocument = <ThrowOnError extends boolean = false>(
  options: Options<GetDocumentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetDocumentResponses,
    GetDocumentErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/v2/customer-terms/documents/{termName}",
    ...options,
  });

/**
 * Check whether the authenticated user has agreed to the latest version of a term
 */
export const validateAgreement = <ThrowOnError extends boolean = false>(
  options: Options<ValidateAgreementData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ValidateAgreementResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/customer-terms/agreements/{termName}/validate",
    ...options,
  });

/**
 * Record that the authenticated user has agreed to the latest version of a term
 */
export const createAgreement = <ThrowOnError extends boolean = false>(
  options: Options<CreateAgreementData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAgreementResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/customer-terms/agreements",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

export const getQuestions = <ThrowOnError extends boolean = false>(
  options?: Options<GetQuestionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetQuestionsResponses, unknown, ThrowOnError>(
    {
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v2/trivia/questions",
      ...options,
    }
  );

export const submitAnswer = <ThrowOnError extends boolean = false>(
  options: Options<SubmitAnswerData, ThrowOnError>
) =>
  (options.client ?? client).post<SubmitAnswerResponses, unknown, ThrowOnError>(
    {
      responseType: "json",
      security: [{ scheme: "bearer", type: "http" }],
      url: "/api/v2/trivia/answers",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    }
  );

/**
 * Get insights for the authenticated user
 */
export const getInsights = <ThrowOnError extends boolean = false>(
  options?: Options<GetInsightsData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetInsightsResponses, unknown, ThrowOnError>({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/insights",
    ...options,
  });

/**
 * Create insights for a custom date range
 */
export const createInsight = <ThrowOnError extends boolean = false>(
  options: Options<CreateInsightData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateInsightResponses,
    CreateInsightErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/insights",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get the latest insight for the authenticated user
 */
export const getLatestInsight = <ThrowOnError extends boolean = false>(
  options?: Options<GetLatestInsightData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetLatestInsightResponses,
    GetLatestInsightErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/insights/latest",
    ...options,
  });

/**
 * Get a specific insight by ID for the authenticated user
 */
export const getInsight = <ThrowOnError extends boolean = false>(
  options: Options<GetInsightData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetInsightResponses,
    GetInsightErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/insights/{id}",
    ...options,
  });

/**
 * Search properties by associated entity type and ID
 */
export const searchByAssociatedEntity = <ThrowOnError extends boolean = false>(
  options: Options<SearchByAssociatedEntityData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SearchByAssociatedEntityResponses,
    SearchByAssociatedEntityErrors,
    ThrowOnError
  >({ url: "/api/v2/internal/properties", ...options });

/**
 * Generate an invite link or return existing user info
 */
export const getSignupLink = <ThrowOnError extends boolean = false>(
  options: Options<GetSignupLinkData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GetSignupLinkResponses,
    GetSignupLinkErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/internal/links/signup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Send an invite email with a signup link
 */
export const createInvite = <ThrowOnError extends boolean = false>(
  options: Options<CreateInviteData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateInviteResponses,
    CreateInviteErrors,
    ThrowOnError
  >({
    url: "/api/v2/invites",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get all available tasks
 */
export const getTasks = <ThrowOnError extends boolean = false>(
  options?: Options<GetTasksData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetTasksResponses, unknown, ThrowOnError>({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/tasks",
    ...options,
  });

/**
 * Create a user quest
 */
export const postQuest = <ThrowOnError extends boolean = false>(
  options: Options<PostQuestData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostQuestResponses,
    PostQuestErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/quests/{questConfigId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update a user quest
 */
export const putQuest = <ThrowOnError extends boolean = false>(
  options: Options<PutQuestData, ThrowOnError>
) =>
  (options.client ?? client).put<
    PutQuestResponses,
    PutQuestErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/quests/{questConfigId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get Palmetto Wrapped 2025 data for authenticated user
 */
export const getWrapped2025 = <ThrowOnError extends boolean = false>(
  options?: Options<GetWrapped2025Data, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetWrapped2025Responses,
    GetWrapped2025Errors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/wrapped/2025",
    ...options,
  });

/**
 * Get OTP delivery options for a user
 */
export const getOtpOptions = <ThrowOnError extends boolean = false>(
  options: Options<GetOtpOptionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetOtpOptionsResponses,
    GetOtpOptionsErrors,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/v3/login/otp-options",
    ...options,
  });

/**
 * Returns a user if one is available for logging in
 */
export const getUser = <ThrowOnError extends boolean = false>(
  options: Options<GetUserData, ThrowOnError>
) =>
  (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>(
    {
      responseType: "json",
      url: "/api/v3/login/users",
      ...options,
    }
  );

/**
 * Send OTP code to a user
 */
export const sendOtp = <ThrowOnError extends boolean = false>(
  options: Options<SendOtpData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SendOtpResponses,
    SendOtpErrors,
    ThrowOnError
  >({
    url: "/api/v3/login/otp",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Login with email/password or phone/password
 */
export const login = <ThrowOnError extends boolean = false>(
  options: Options<LoginData, ThrowOnError>
) =>
  (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    responseType: "json",
    url: "/api/v3/login",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Sign up with a signup token or OTP code
 */
export const signup = <ThrowOnError extends boolean = false>(
  options: Options<SignupData, ThrowOnError>
) =>
  (options.client ?? client).post<SignupResponses, SignupErrors, ThrowOnError>({
    url: "/api/v3/signup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create OTP user and send OTP code
 */
export const sendOtp2 = <ThrowOnError extends boolean = false>(
  options: Options<SendOtp2Data, ThrowOnError>
) =>
  (options.client ?? client).post<
    SendOtp2Responses,
    SendOtp2Errors,
    ThrowOnError
  >({
    url: "/api/v3/signup/otp",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Check if the auth cookie is valid
 */
export const getAuthStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthStatusData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetAuthStatusResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/v2/auth/status",
    ...options,
  });

/**
 * Clear the auth cookie
 */
export const authLogout = <ThrowOnError extends boolean = false>(
  options?: Options<AuthLogoutData, ThrowOnError>
) =>
  (options?.client ?? client).post<AuthLogoutResponses, unknown, ThrowOnError>({
    url: "/api/v2/auth/logout",
    ...options,
  });

/**
 * Generate a single-use token for auth exchange
 */
export const generateSutV2 = <ThrowOnError extends boolean = false>(
  options?: Options<GenerateSutV2Data, ThrowOnError>
) =>
  (options?.client ?? client).post<
    GenerateSutV2Responses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    url: "/api/v2/auth/suts",
    ...options,
  });

/**
 * Exchange a SUT for an auth token
 */
export const exchangeSutForTokenV2 = <ThrowOnError extends boolean = false>(
  options: Options<ExchangeSutForTokenV2Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    ExchangeSutForTokenV2Responses,
    unknown,
    ThrowOnError
  >({ url: "/api/v2/auth/suts/auth-token", ...options });

/**
 * Search feed items owned by the authenticated user, or every feed item on one of their projects when projectId is provided
 */
export const searchFeedItems = <ThrowOnError extends boolean = false>(
  options?: Options<SearchFeedItemsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    SearchFeedItemsResponses,
    SearchFeedItemsErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/feed-items/search",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Update the status of a feed item owned by the authenticated user
 */
export const updateFeedItemStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFeedItemStatusData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    UpdateFeedItemStatusResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/feed-items/{id}/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get all finance accounts for the authenticated user
 */
export const getFinanceAccounts = <ThrowOnError extends boolean = false>(
  options?: Options<GetFinanceAccountsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetFinanceAccountsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/finance-accounts",
    ...options,
  });

/**
 * Get finance account details
 */
export const getFinanceAccount = <ThrowOnError extends boolean = false>(
  options: Options<GetFinanceAccountData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFinanceAccountResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/finance-accounts/{id}",
    ...options,
  });

/**
 * Stream finance account document
 */
export const getFinanceAccountDocument = <ThrowOnError extends boolean = false>(
  options: Options<GetFinanceAccountDocumentData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFinanceAccountDocumentResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/finance-accounts/{id}/document",
    ...options,
  });

/**
 * Get finance account documents
 */
export const getFinanceAccountDocuments = <
  ThrowOnError extends boolean = false
>(
  options: Options<GetFinanceAccountDocumentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetFinanceAccountDocumentsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/finance-accounts/{id}/documents",
    ...options,
  });

/**
 * Submit a payment for a finance account
 */
export const postPayment = <ThrowOnError extends boolean = false>(
  options: Options<PostPaymentData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostPaymentResponses,
    PostPaymentErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/finance-accounts/{id}/payments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Cancel a scheduled (pending) payment
 */
export const cancelPayment = <ThrowOnError extends boolean = false>(
  options: Options<CancelPaymentData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    CancelPaymentResponses,
    CancelPaymentErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/finance-accounts/{id}/payments/{paymentId}",
    ...options,
  });

/**
 * Get saved payment methods for a project or finance account
 */
export const getPaymentMethods = <ThrowOnError extends boolean = false>(
  options: Options<GetPaymentMethodsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPaymentMethodsResponses,
    GetPaymentMethodsErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/payment-methods",
    ...options,
  });

/**
 * Add a payment method for a project or finance account
 */
export const createPaymentMethod = <ThrowOnError extends boolean = false>(
  options: Options<CreatePaymentMethodData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePaymentMethodResponses,
    CreatePaymentMethodErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/payment-methods",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete a saved payment method for a project or finance account
 */
export const deletePaymentMethod = <ThrowOnError extends boolean = false>(
  options: Options<DeletePaymentMethodData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeletePaymentMethodResponses,
    DeletePaymentMethodErrors,
    ThrowOnError
  >({
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/payment-methods/{methodId}",
    ...options,
  });

/**
 * Set a payment method as the default (auto-pay) method, or update its nickname
 */
export const setDefaultPaymentMethod = <ThrowOnError extends boolean = false>(
  options: Options<SetDefaultPaymentMethodData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    SetDefaultPaymentMethodResponses,
    SetDefaultPaymentMethodErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/payment-methods/{methodId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a short-lived Plaid Link token for the authenticated user
 */
export const createPlaidLinkToken = <ThrowOnError extends boolean = false>(
  options: Options<CreatePlaidLinkTokenData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePlaidLinkTokenResponses,
    CreatePlaidLinkTokenErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/plaid/link-token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Exchange a Plaid public token and store the verified bank account as a payment method
 */
export const verifyPlaidAccount = <ThrowOnError extends boolean = false>(
  options: Options<VerifyPlaidAccountData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VerifyPlaidAccountResponses,
    VerifyPlaidAccountErrors,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/plaid/verify-account",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get paginated point transaction history for the authenticated user
 */
export const getPointTransactions = <ThrowOnError extends boolean = false>(
  options?: Options<GetPointTransactionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetPointTransactionsResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/point-transactions",
    ...options,
  });

/**
 * Get all feedback submitted by the authenticated user
 */
export const getUserFeedback = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserFeedbackData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetUserFeedbackResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/user-feedback",
    ...options,
  });

/**
 * Submit feedback for a feature
 */
export const postUserFeedback = <ThrowOnError extends boolean = false>(
  options: Options<PostUserFeedbackData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostUserFeedbackResponses,
    unknown,
    ThrowOnError
  >({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/user-feedback",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Create a new private media upload slot and get a signed upload URL
 */
export const createMedia = <ThrowOnError extends boolean = false>(
  options: Options<CreateMediaData, ThrowOnError>
) =>
  (options.client ?? client).post<CreateMediaResponses, unknown, ThrowOnError>({
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/media",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Upload a file to private media storage
 */
export const uploadMedia = <ThrowOnError extends boolean = false>(
  options: Options<UploadMediaData, ThrowOnError>
) =>
  (options.client ?? client).post<UploadMediaResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: "json",
    security: [{ scheme: "bearer", type: "http" }],
    url: "/api/v2/media/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
